import React from "react";
import Header from "../../components/Header/Header";
import UserProfile from "../../sections/UserProfile/UserProfile";
import "./Profile.css";

function Profile() {
  return (
    <main className="Profile">
      <Header
        title="My Account"
        subtitle="Access your account settings here."
      />
      <UserProfile />
    </main>
  );
}

export default Profile;
